import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme/theme.ts";
import { PostHogProvider } from "posthog-js/react";
import { QueryClient } from "@tanstack/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import { registerSW } from "virtual:pwa-register";
import { POSTHOG_KEY } from "./api/base.tsx";

registerSW({ immediate: true });

const options = {
  api_host: "https://us.i.posthog.com",
  disable_session_recording: true,
  autocapture: false,
};

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </PostHogProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
